// 1st view のカルーセル

import Splide from '@splidejs/splide'

export function splider() {
  const selector = document.querySelector('.splide')
  if (selector === null) return

  const main = new Splide('.splide-main', {
    type: 'fade',
    pagination: false,
    arrows: false
  })

  // サムネイル
  const thumbnails = new Splide('.splide-thumbnail', {
    perPage: 3,
    fixedWidth: '88px',
    pagination: false,
    isNavigation: true,
    focus: 0,
    arrows: false
  })

  main.sync(thumbnails)
  main.mount()
  thumbnails.mount()
}
